<template>
    <div class="comment-editor">
        <div class="comment-editor-body">
            <editor-content :editor="editor"/>
        </div>
        <div class="comment-editor-footer">
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                <div class="menubar">
                    <button class="menubar__button" @click="openEmoji">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14.756" height="14.316"
                             viewBox="0 0 14.756 14.316">
                            <g transform="translate(0.44)">
                                <circle cx="7" cy="7" r="7" transform="translate(-0.44)" fill="#ffd93b"/>
                                <path
                                    d="M101.487,287.763a4.576,4.576,0,0,1-4.435-3.447.3.3,0,1,1,.578-.148,3.98,3.98,0,0,0,7.714,0,.3.3,0,0,1,.578.148A4.575,4.575,0,0,1,101.487,287.763Z"
                                    transform="translate(-94.329 -276.004)" fill="#3e4347"/>
                                <path
                                    d="M69.45,62.292a7.158,7.158,0,0,1-12.73,4.494A7.158,7.158,0,0,0,66.786,56.72,7.15,7.15,0,0,1,69.45,62.292Z"
                                    transform="translate(-55.134 -55.134)" fill="#f4c534"/>
                                <ellipse cx="1.097" cy="1.304" rx="1.097" ry="1.304" transform="translate(3.749 4.856)"
                                         fill="#3e4347"/>
                                <path
                                    d="M177.6,195.161a.236.236,0,0,1-.316-.075.2.2,0,1,1,.306-.251A.237.237,0,0,1,177.6,195.161Z"
                                    transform="translate(-172.258 -189.282)" fill="#5a5f63"/>
                                <ellipse cx="1.097" cy="1.304" rx="1.097" ry="1.304" transform="translate(8.374 4.856)"
                                         fill="#3e4347"/>
                                <path
                                    d="M342.959,195.161a.236.236,0,0,1-.316-.075.2.2,0,1,1,.306-.251A.237.237,0,0,1,342.959,195.161Z"
                                    transform="translate(-332.994 -189.282)" fill="#5a5f63"/>
                            </g>
                        </svg>
                    </button>
                    <button class="menubar__button" @click="openImages" v-if="!image">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.356" height="12.395"
                             viewBox="0 0 16.356 12.395">
                            <path
                                d="M45.554,35.3v2.828A4.4,4.4,0,0,0,42.306,39.8l-1.458,1.23a.606.606,0,0,1-.773.01l-2.111-1.688a.6.6,0,0,0-.783.021l-2.276,1.919V35.3Zm0,0"
                                transform="translate(-33.791 -34.185)" fill="#c9d653"/>
                            <path
                                d="M40.852,160.038l1.458-1.23a4.184,4.184,0,0,0-.643,2.475,5.5,5.5,0,0,0,.084.965H34.906V160.3l2.276-1.916a.612.612,0,0,1,.783-.021l2.111,1.688A.611.611,0,0,0,40.852,160.038Zm0,0"
                                transform="translate(-33.791 -153.19)" fill="#00acea"/>
                            <path
                                d="M12.878.5V4.506a4.363,4.363,0,0,0-.832-.08c-.129,0-.259.007-.384.018V1.72H1.22V9.452H7.963a4.276,4.276,0,0,0,.444,1.213l-.01.007H0V.5Zm0,0"
                                transform="translate(0 -0.5)" fill="#032353"/>
                            <path
                                d="M242.35,124.065a4.341,4.341,0,0,1-.084-.86,4.308,4.308,0,0,1,3.926-4.289c.126-.01.255-.017.384-.017a4.307,4.307,0,1,1-3.779,6.376A4.121,4.121,0,0,1,242.35,124.065Zm0,0"
                                transform="translate(-234.527 -115.116)" fill="#fedb41"/>
                            <path d="M173.449,91.324a.993.993,0,1,1-1,.993A.992.992,0,0,1,173.449,91.324Zm0,0"
                                  transform="translate(-166.944 -88.423)" fill="#fedb41"/>
                            <path
                                d="M332.433,206.324h-.86v-.849a.35.35,0,0,0-.7,0v.849h-.825a.35.35,0,0,0,0,.7h.825v.849a.35.35,0,0,0,.7,0v-.849h.86a.35.35,0,0,0,0-.7Zm0,0"
                                transform="translate(-319.167 -198.588)" fill="#032353"/>
                        </svg>
                    </button>
                    <button class="menubar__button is--postcomment" @click="savePosting">
                        <i class="zond-send"></i>
                    </button>
                </div>
            </editor-menu-bar>
            <div v-if="showEmoji" class="editor-emoji-picker test" v-click-outside="hideEmoji"
                 v-bind:style="{top: emojiY + 'px', left: emojiX + 'px' }">
                <VEmojiPicker @select="selectEmoji" :continuousList="true"/>
            </div>
        </div>
        <div class="comment-editor-action">
            <button class="btn btn-secondary btn-simple" @click="savePosting">Absenden</button>
        </div>
        <div class="comment-editor-image" v-if="!!image">
            <img :src="'media/user/' + image">
            <div class="back">
                <button class="comment-editorremove" @click="removeImage">Datei entfernen</button>
            </div>
        </div>
        <div class="suggestion-list" v-show="showSuggestions" ref="suggestions">
            <template v-if="hasResults">
                <div
                    v-for="(user, index) in filteredUsers"
                    :key="user.id"
                    class="suggestion-list__item"
                    :class="{ 'is-selected': navigatedUserIndex === index }"
                    @click="selectUser(user)"
                >
                    <div class="image">
                        <img v-if="user.image" :src=user.image :alt=user.name>
                        <span v-else class="icon-camera"></span>
                    </div>
                    <div class="text">
                        {{ user.name }}
                        <span v-if="user.companyName" class="small"> <br>{{ user.companyName }}</span>
                    </div>
                </div>
            </template>
            <div v-else class="suggestion-list__item is-empty">
                Keine Nutzer gefunden
            </div>
        </div>
        <link-preview-small
            :preview-data="previewData"
            :preview-link="previewLink"
            :preview-stat="previewStat"
            :preview-show-slide="previewShowSlide"
            :preview-remove="removePreView">
        </link-preview-small>
        <input class="file-upload" type="file" hidden @change="onFileChange">
    </div>
</template>

<script>
import Fuse from 'fuse.js';
import axios from 'axios';
import tippy from 'tippy.js';
import ClickOutside from 'vue-click-outside';
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {Placeholder, Link} from 'tiptap-extensions';
import {VEmojiPicker} from 'v-emoji-picker';
import CustomMention from './extensions/Mention';
import LinkPreviewSmall from '@/components/LinkPreviewSmall';
import config from './config';
import EnterHandler from './extensions/EnterHandler'; // eslint-disable-line
function decodeEntities (encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}

/* global $ */
export default {
    components: {
        LinkPreviewSmall,
        EditorMenuBar,
        EditorContent,
        VEmojiPicker
    },
    data () {
        return {
            // Create an `Editor` instance with some default content. The editor is
            // then passed to the `EditorContent` component as a `prop`
            newsId: '',
            showEmoji: false,
            emojiX: 0,
            emojiY: 0,
            query: null,
            suggestionRange: null,
            json: '',
            html: '',
            filteredUsers: [],
            navigatedUserIndex: 0,
            image: '',
            commentNewsID: '',
            commenIDMain: 0,
            commentID: '',
            previewData: null,
            previewStat: '',
            previewLink: '',
            previewShowSlide: false,
            insertMention: () => {
            },
            observer: null,
            editor: new Editor({
                content: '',
                extensions: [
                    // The editor will accept paragraphs and headline elements as part of its document schema.
                    new Placeholder({
                        emptyNodeText: 'Kommentieren...',
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true
                    }),
                    new Link({}),
                    new CustomMention({
                        matcher: {
                            allowSpaces: true
                        },
                        // a list of all suggested items
                        items: () => [],
                        // is called when a suggestion starts
                        onEnter: ({range, command}) => {
                            this.suggestionRange = range;
                            // we save the command for inserting a selected mention
                            // this allows us to call it inside of our custom popup
                            // via keyboard navigation and on click
                            this.insertMention = command;
                        },
                        // is called when a suggestion has changed
                        onChange: ({query, range, virtualNode}) => {
                            let _this = this;
                            if (query.length > 0) {
                                axios.post(config().api, {
                                    query: query,
                                    modus: 'searchUsersEditor'
                                })
                                    .then(function (response) {
                                        _this.query = query;
                                        _this.filteredUsers = response.data;
                                        _this.suggestionRange = range;
                                        _this.navigatedUserIndex = 0;
                                        _this.renderPopup(virtualNode);
                                    })
                                    .catch(function (error) {
                                        window.console.log(error);
                                    });

                            } else {
                                this.query = null;
                                this.filteredUsers = [];
                                this.suggestionRange = null;
                                this.navigatedUserIndex = 0;
                                this.destroyPopup();
                            }

                        },
                        // is called when a suggestion is cancelled
                        onExit: () => {
                            // reset all saved values
                            this.query = null;
                            this.filteredUsers = [];
                            this.suggestionRange = null;
                            this.navigatedUserIndex = 0;
                            this.destroyPopup();
                        },
                        // is called on every keyDown event while a suggestion is active
                        onKeyDown: ({event}) => {
                            if (event.keyCode === 38 || event.key === 'ArrowUp') {
                                this.upHandler();
                                return true;
                            }
                            // pressing down arrow
                            if (event.keyCode === 40 || event.key === 'ArrowDown') {
                                this.downHandler();
                                return true;
                            }
                            // pressing enter
                            if (event.keyCode === 13 || event.key === 'Enter') {
                                this.enterHandler();
                                return true;
                            }
                            return false;
                        },
                        // is called when a suggestion has changed
                        // this function is optional because there is basic filtering built-in
                        // you can overwrite it if you prefer your own filtering
                        // in this example we use fuse.js with support for fuzzy search
                        onFilter: (items, query) => {
                            if (!query) {
                                return items;
                            }
                            const fuse = new Fuse(items, {
                                tokenize: true,
                                threshold: 0.6,
                                keys: ['name']
                            });
                            return fuse.search(query);
                        }
                    }),
                    /*new EnterHandler({
                        onEnter: (view, event) => {
                            if (event.key === 'Enter' && !event.shiftKey) {
                                this.savePosting();
                                return true;
                            }
                            return false;
                        }
                    })*/
                ],
                onUpdate: ({getHTML, getJSON}) => {
                    var links = decodeEntities(getHTML()).match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);
                    var _this = this;
                    if (this.previewLink === '' && links && links.length > 0 && links[0] !== _this.previewLink) {
                        _this.previewStat = 'pending';
                        _this.previewLink = links[0];
                        axios.post(config().api, {
                            link: links[0],
                            modus: 'getLinkPreview'
                        })
                            .then(function (response) {
                                if (typeof response.data === 'object' && response.data.length !== 0) {
                                    _this.setLinkPreview(response.data);
                                    _this.editor.setContent(_this.html.replace(/<a [^>]+>(.*?)<\/a>/, ''));
                                    // _this.editor.setContent(_this.html.replace(/<a [^>]+>(.*?)<\/a>/, '<a href="' + links[0] + '" rel="noreferrer noopener nofollow">' + response.data.title + '</a>'));
                                    _this.json = getJSON();
                                    _this.html = getHTML();
                                } /*else {
                                      _this.removePreView();
                                  }*/
                            })
                            .catch(function (error) {
                                window.console.log(error);
                            });
                    } else if (!links || links.length === 0) {
                        _this.removePreView();
                    }
                    this.json = getJSON();
                    this.html = getHTML();
                }
            })
        };
    },
    methods: {
        selectEmoji (emoji) {
            const transaction = this.editor.state.tr.insertText(emoji.data);
            this.editor.view.dispatch(transaction);
        },
        openEmoji (event) {
            this.showEmoji = !this.showEmoji;
            this.emojiX = event.clientX;
            this.emojiY = event.clientY + 10;
            if (this.emojiX > ($(window).width() - 330)) {
                this.emojiX = $(window).width() - 330;
            }
            window.console.log(event);
        },
        handleScroll () {
            this.showEmoji = false;
        },
        hideEmoji () {
            if (this.showEmoji === true) {
                this.showEmoji = false;
            }

        },
        setLinkPreview (data) {
            this.previewData = data;
            this.previewStat = 'show';
            let img = '';
            this.previewShowSlide = false;
            if (data.cover) {
                img = data.cover;
            } else if (typeof data.images === 'object') {
                let keys = Object.keys(data.images);
                img = data.images[keys[0]];
                this.previewShowSlide = keys.length > 1;
            }
            this.previewImage = img;
        },
        removePreView (e) {
            if (typeof e !== 'undefined') {
                e.preventDefault();
            }
            this.previewData = null;
            this.previewStat = '';
            this.previewLink = '';
            this.previewShowSlide = false;
            return false;
        },
        // navigate to the previous item
        // if it's the first item, navigate to the last one
        upHandler () {
            this.navigatedUserIndex = ((this.navigatedUserIndex + this.filteredUsers.length) - 1) % this.filteredUsers.length;
        },
        // navigate to the next item
        // if it's the last item, navigate to the first one
        downHandler () {
            this.navigatedUserIndex = (this.navigatedUserIndex + 1) % this.filteredUsers.length;
        },
        enterHandler () {
            const user = this.filteredUsers[this.navigatedUserIndex];

            if (user) {
                this.selectUser(user);
            }
        },
        // we have to replace our suggestion text with a mention
        // so it's important to pass also the position of your suggestion text
        selectUser (user) {
            this.insertMention({
                range: this.suggestionRange,
                attrs: {
                    id: user.id,
                    label: user.name,
                    type: user.type
                }
            });
            this.editor.focus();
        },
        // renders a popup with suggestions
        // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
        renderPopup (node) {
            if (this.popup) {
                return;
            }

            this.popup = tippy(node, {
                content: this.$refs.suggestions,
                trigger: 'mouseenter',
                interactive: true,
                theme: 'dark',
                placement: 'top-start',
                inertia: true,
                duration: [400, 200],
                showOnInit: true,
                arrow: true,
                arrowType: 'round'
            });

            // we have to update tippy whenever the DOM is updated
            if (MutationObserver) {
                this.observer = new MutationObserver(() => {
                    this.popup.popperInstance.scheduleUpdate();
                });
                this.observer.observe(this.$refs.suggestions, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
            }
        },
        destroyPopup () {
            if (this.popup) {
                this.popup.destroy();
                this.popup = null;
            }

            if (this.observer) {
                this.observer.disconnect();
            }
        },
        savePosting () {
            let _this = this;
            axios.post(config().api, {
                image: _this.image,
                content: _this.html,
                newsID: _this.commentNewsID,
                commentID: _this.commentID,
                commentIDSub: _this.commenIDMain,
                commentLinkData: JSON.stringify({
                    ...this.previewData,
                    link: this.previewLink
                }),
                modus: 'saveComment'
            })
                .then(function ({data}) {
                    if (data.error === false) {
                        let newsfeed = $('#newsfeed-' + _this.commentNewsID);
                        if (data.update) {
                            let _container = $('#newsfeed-' + _this.commentNewsID).find('#comment-' + data.contentID);
                            $(_container.find('.comment__text')[0]).html(data.htmlText);
                            $(_container.find('.comment__image-content')[0]).html(data.htmlImage);

                            $('#change-comment-modal').removeClass('open');
                            $('#modal-body-comment').html('<div class="form-item width-100 emoji-picker-container" style="position: relative"\n' +
                                '                     id="change-comment-main" data-comment-editor\n' +
                                '                     data-news-id=""\n' +
                                '                     data-comment-id=""\n' +
                                '                     data-comment-main="">\n' +
                                '                    <div id="changecomment"></div>\n' +
                                '                </div>');
                        } else {

                            let newscommentBox = newsfeed.find('.newsbox__comments_inner');
                            let commentBox;
                            if (_this.commenIDMain !== 0 && _this.commenIDMain !== '') {
                                commentBox = $('#comment-' + _this.commenIDMain);
                                var commentBoxUl = commentBox.find('ul');
                                if (commentBoxUl.length > 0) {
                                    commentBoxUl.append(data.html);
                                } else {
                                    commentBox.append('<ul>' + data.html + '</ul>');
                                }
                            } else {
                                let newscommentBoxList = newsfeed.find('.newsbox__comments_inner > ul');
                                newscommentBoxList.append(data.html);
                                newscommentBox.scrollTop(newscommentBox[0].scrollHeight);
                            }

                        }
                        let closeContainer = newsfeed.find('.newsbox__comments_inner');
                        if (closeContainer.height() < 250) {
                            closeContainer.addClass('no-overflow');
                        } else {
                            closeContainer.removeClass('no-overflow');
                        }
                        _this.image = '';
                        _this.html = '';
                        _this.showEmoji = false;
                        _this.editor.clearContent(true);
                        window.emojiPicker.discover();
                        $(document).trigger('testEvent', [1011]);
                    }
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        },
        openImages () {
            $(this.$el).find('.file-upload')[0].click();
        },
        onFileChange (e) {
            let _this = this;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            let formData = new FormData();

            formData.append('file', files[0]);
            axios.post(config().imageUploadUrl,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(function ({data}) {
                    if (data.type === 'success') {
                        window.console.log(_this);
                        _this.image = data.fileName;
                    }
                    window.console.log(data);
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        },
        removeImage (e) {
            e.preventDefault();
            let _this = this;
            axios.post(config().api, {
                fileName: this.image,
                modus: 'removeImageComment'
            })
                .then(function ({data}) {
                    if (data.type === 'success') {
                        _this.image = '';
                    }
                })
                .catch(function (error) {
                    window.console.log(error);
                });
            return false;
        }
    },
    computed: {
        hasResults () {
            return this.filteredUsers.length;
        },
        showSuggestions () {
            return this.query || this.hasResults;
        }
    },

    beforeDestroy () {
        // Always destroy your editor instance when it's no longer needed
        this.editor.destroy();
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted () {
        this.popupItem = this.$el;
        let _this = this;
        let _parent = $(this.$el).closest('[data-comment-editor]');
        let commentNewsID = _parent.attr('data-news-id');
        let commenIDMain = _parent.attr('data-comment-main');
        let commentID = _parent.attr('data-comment-id');
        _this.commentNewsID = commentNewsID;
        _this.commenIDMain = commenIDMain;
        _this.commentID = commentID;
        if (typeof commentID !== 'undefined' && commentID !== '') {
            axios.post(config().api, {
                commentID: commentID,
                modus: 'getComment'
            })
                .then(function ({data}) {
                    _this.image = data.nfcImage;
                    _this.commenIDMain = data.nfcCommentParent;
                    _this.commentNewsID = data.nfcNewsID_FK;
                    _this.html = data.nfcContent;
                    _this.editor.setContent(data.nfcContent);
                    if (data.nfcLinkData !== null) {
                        let linkdata = JSON.parse(data.nfcLinkData);
                        if (linkdata.link !== '') {
                            _this.previewLink = linkdata.link;
                            _this.setLinkPreview({
                                cover: linkdata.cover,
                                images: linkdata.images,
                                title: linkdata.title,
                                description: linkdata.description,
                                video: linkdata.video,
                                videoType: linkdata.videoType
                            });
                        }

                    }

                })
                .catch(function (error) {
                    window.console.log(error);
                });
        }
    },
    directives: {
        ClickOutside
    }
};
</script>

<style lang="scss">
.comment-editor {
    position: relative;

    *.is-empty:nth-child(1)::before,
    *.is-empty:nth-child(2)::before {
        content: attr(data-empty-text);
        float: left;
        color: #aaa;
        pointer-events: none;
        height: 0;
        font-style: italic;
    }

    &-body {
        width: 100%;
        border-radius: 20px;
        background: #ededed;
        padding: 7px 60px 7px 20px;
    }

    .ProseMirror {
        outline: 0;
        line-height: 1.5;
        font-size: 13px;
        width: 100%;

        p {
            margin: 0;
            line-height: 1.5;
            font-size: 13px;
        }
    }

    &-footer {
        position: absolute;
        right: 5px;
        top: 4px;

        .menubar__button {
            outline: none;
            background: transparent;
            -webkit-appearance: none;
            border: none;
            padding: 5px;
        }
    }

    .editor-emoji-picker {
        position: fixed;
        z-index: 100;
    }

    .comment-editor-image {
        max-width: 200px;
        margin-top: 10px;
        position: relative;
        display: block;
        padding-left: 0;
        margin-left: 10px;
        overflow: hidden;

        .back {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            background-color: rgba(33, 150, 243, .8);
            display: flex;
            justify-content: flex-end;
            align-content: center;
            align-items: center;
            flex-direction: column;
            opacity: 0;
        }

        &:hover {
            .back {
                -webkit-animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            }
        }

        .comment-editorremove {
            z-index: 30;
            color: #fff;
            padding: 10px;
            top: inherit;
            bottom: 15px;
            border: 2px #fff solid;
            text-decoration: none;
            text-transform: uppercase;
            font-size: .8rem;
            font-weight: 800;
            letter-spacing: 1.1px;
            -webkit-appearance: none;
            background: transparent;
            margin: 0;
            margin-bottom: 20px;

            &:hover {
                text-decoration: underline;
            }
        }
    }


}

@-webkit-keyframes slide-in-bottom {
    0% {
        -webkit-transform: translateY(1000px);
        transform: translateY(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-bottom {
    0% {
        -webkit-transform: translateY(1000px);
        transform: translateY(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

</style>
